module.exports = __webpack_public_path__ + "static/assets/5bb737f3f140709aef65412af158aaf3.svg";